import { listenTo, createRef } from './helpers';
import { Database } from 'firebase/database';

export default function onChildRemovedFactory(database: Database) {
  return function onChildRemovedFunction(
    this: any,
    path: string,
    signal: string,
    options: Parameters<typeof createRef>[2] & {
      payload?: Record<string, any>;
    } = {}
  ) {
    listenTo(
      createRef(database, path, options),
      path,
      'child_removed',
      signal,
      (data) => {
        this.context.app.getSequence(signal)({
          key: data.key,
          ...options.payload,
        });
      }
    );
  };
}
